import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenDeviceEndpointsService extends LorenBaseEndpointsService {

    public devices() {
        return `${this.getApiServerUrl()}/devices`;
    }
}
